import {
  Component,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';


interface CompanyFeature {
  icon: string;
  title: string;
  text: string;
}

@Component({
  selector: 'app-forcompany',
  templateUrl: './forcompany.component.html',
  styleUrl: './forcompany.component.scss'
})
export class ForcompanyComponent {
    private isBrowser = false;
    constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {


    this.isBrowser = isPlatformBrowser(this.platformId);


  }

  currentLanguage = 'en';
features = [
  {
    iconImg: '/assets/as/18.webp',
      title: 'atw.companies.featureFreeTitle',
      text: 'atw.companies.featureFreeText'
  },
  {
    iconImg: '/assets/as/8.png',
      title: 'atw.companies.featureFastTitle',
      text: 'atw.companies.featureFastText'
  },
  {
    iconImg: '/assets/as/17.webp',
      title: 'atw.companies.featureMatchTitle',
      text: 'atw.companies.featureMatchText'
  },
];


  ngOnInit(): void{

          if (this.isBrowser) {
      this.currentLanguage = localStorage.getItem('language') || 'en';
    }

}
}